<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      label-width="120px"
      :toolbar="toolbar"
    />
  </div>
</template>
<script>
export default {
  name: 'Liuliangfangan',
  components: {},
  data() {
    return {
      url: '/business/traffic/page',
      columns: [
        {
          label: '方案名称',
          prop: 'name'
        },
        {
          label: '流量方',
          prop: 'trafficOrgName'
        },
        {
          label: '提供方',
          prop: 'provider',
          template: function(index, record) {
            return record.provider == '0' ? '全平台直联' : (record.provider == '1' ? '加盟直联' : '互联互通')
          }
        },
        {
          label: '运营商',
          prop: 'operatorOrgName',
          template: function(index, record) {
            return record.operatorOrgName ? record.operatorOrgName : '--'
          }
        },
        {
          label: '电费优惠类型',
          prop: 'electricityType',
          template: function(index, record) {
            return record.electricityType == 'fixed' ? '固定价格' : '固定折扣'
          }
        },
        {
          label: '电费折扣',
          prop: 'electricity',
          template: function(index, record) {
            if (record.electricityType == 'fixed') {
              return record.electricity + '元'
            } else {
              return record.electricity + '%'
            }
          }
        },
        {
          label: '服务费优惠类型',
          prop: 'serviceFeeType',
          template: function(index, record) {
            return record.serviceFeeType == 'fixed' ? '固定价格' : '固定折扣'
          }
        },
        {
          label: '服务费折扣',
          prop: 'serviceFee',
          template: function(index, record) {
            if (record.serviceFeeType == 'fixed') {
              return record.serviceFee + '元'
            } else {
              return record.serviceFee + '%'
            }
          }
        },
        {
          label: '授权状态',
          prop: 'authStatusValue'
        }
      ],
      handles: {
        width: 180,
        btns: [
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'valueadd.flow.details',
            handle: resp => {
              this.$router.push({ path: './flowSchemeDetail', query: { data: resp.id }})
            }
          },
          {
            label: '授权',
            permission: 'valueadd.flow.termination',
            url: '/business/traffic/disable',
            method: 'get',
            isConfirm: true,
            confirmText: '确定进行此操作吗？',
            getLabel: function(record) {
              return record.disable ? '授权' : '终止'
            },
            getLabelStyle: record => {
              if (record.cz) {
                return record.disable ? 'color:#00FF00' : 'color:red'
              } else {
                return record.disable ? 'color:#c0c4cc;cursor:not-allowed' : 'color:#c0c4cc;cursor:not-allowed'
              }
            },
            getLabelDisabled: record => {
              return !record.cz
            },
            before: (index, record) => {
              return { id: record.id }
            },
            handle: () => {
              this.$refs.tableref.queryTable()
            }
          },
          {
            label: '推送运营商信息',
            permission: 'valueadd.flow.termination',
            url: '/evserv/evcs/v1/MA2LB0771/MA27UHZZF/notification_equipmentOwnerInfo/3301090001/6744b92c372444f29be2e08fcde39ecd',
            method: 'post',
            isConfirm: true,
            confirmText: '确定进行此操作吗？',
            getLabel: function(record) {
              return record.disable ? '推送运营商信息' : '推送运营商信息'
            },
            getLabelStyle: record => {
              if (record.cz) {
                return record.disable ? 'color:#00FF00' : 'color:red'
              } else {
                return record.disable ? 'color:#c0c4cc;cursor:not-allowed' : 'color:#c0c4cc;cursor:not-allowed'
              }
            },
            getLabelDisabled: record => {
              return !record.cz
            },
            before: (index, record) => {
              return { id: record.id }
            },
            handle: () => {
              this.$refs.tableref.queryTable()
            }
          },
          {
            label: '修改',
            icon: 'el-icon-edit',
            permission: 'valueadd.flow.edit',
            handle: resp => {
              this.$router.push({ 
                path: './reviseFlowScheme', 
                query: { 
                  id: resp.id,
                }
              })
            }
          }
        ]
      },
      // data:[],
      query: [
        {
          label: '方案名称',
          prop: 'name',
          placeholder: '请输入方案名称'
        },
        {
          label: '流量方',
          prop: 'trafficOrgId',
          type: 'select2',
          placeholder: '请输入流量方',
          data: [],
          remoteMethod: (val) => {
            this.getTrafficOrg(val)
          }
        },
        {
          label: '提供方',
          prop: 'provider',
          type: 'select',
          placeholder: '请选择提供方',
          data: [
            {
              label: '全平台直联',
              value: 0
            },
            {
              label: '加盟直联',
              value: 1
            },
            {
              label: '互联互通',
              value: 2
            }
          ]
        },
        {
          label: '运营商',
          prop: 'operatorOrgId',
          type: 'select',
          placeholder: '请选择运营商',
          data: []
        },
        // {
        //   label: '电费优惠类型',
        //   prop: 'electricityType',
        //   type: 'select',
        //   placeholder: '请选择电费优惠类型',
        //   data: [
        //     {
        //       label: '电费折扣',
        //       value: 'discount'
        //     },
        //     {
        //       label: '电费一口价',
        //       value: 'fixed'
        //     }
        //   ]
        // },
        // {
        //   label: '服务费优惠类型',
        //   prop: 'serviceFeeType',
        //   type: 'select',
        //   placeholder: '请选择服务费优惠类型',
        //   data: [
        //     {
        //       label: '服务费折扣',
        //       value: 'discount'
        //     },
        //     {
        //       label: '服务费一口价',
        //       value: 'fixed'
        //     }
        //   ]
        // },
        {
          label: '授权状态',
          prop: 'status',
          type: 'select',
          placeholder: '请选择授权状态',
          data: [
            {
              label: '未开始',
              value: 0
            },
            {
              label: '进行中',
              value: 1
            },
            {
              label: '已结束（自动到期）',
              value: 2
            },
            {
              label: '已结束（手动停用）',
              value: 3
            }
          ]
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'valueadd.flow.add',
          type: 'primary',
          handle: resp => {
            this.$router.push({ path: './addFlowScheme' })
          }
        }
      ]

    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.getTrafficOrg()
    this.getOperatorOrg()
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    getTrafficOrg(val) {
      this.query[1].data = []
      const data = {
        orgName: val
      }
      this.$store.dispatch('form/handle', {
        url: '/business/traffic/getTrafficOrg',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp) {
            this.query[1].data = resp
          }
        }
      })
    },
    getOperatorOrg(val) {
      const data = {
        orgTypes: '0,3',
        showOperatorName: true
      }
      this.$store.dispatch('form/handle', {
        url: '/business/discountterm/getResponsibleOrgTree',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp && resp.length > 0) {
            resp.forEach(item => {
              item.label = item.name
              item.value = item.id
            })
          }
          this.query[3].data = resp
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

  <style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/flowScheme/flowScheme.vue